import { render, staticRenderFns } from "./DetailProyectOC.vue?vue&type=template&id=f17bd9de&scoped=true&"
import script from "./DetailProyectOC.vue?vue&type=script&lang=js&"
export * from "./DetailProyectOC.vue?vue&type=script&lang=js&"
import style0 from "./DetailProyectOC.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailProyectOC.vue?vue&type=style&index=1&id=f17bd9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17bd9de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VIcon,VLayout,VTab,VTabItem,VTabs,VTabsItems})
